Lyte.Component.register( 'lyte-svg', {
	data: function() {
		return {
			ltPropViewBox: Lyte.attr( 'string', { 'default': '' } ),
			ltPropClass: Lyte.attr( 'string', { 'default': '' } ),
			ltPropPath: Lyte.attr( 'string' ),
			ltPropId: Lyte.attr( 'string', { 'default': '' } ),
			flag: Lyte.attr( 'boolean', { default: false } )
		}		
	},

	didConnect: function() {
		this.setData( 'flag', true );
	}
} );